module.exports = __webpack_public_path__ + "static/media/iconclose.a4bd607e.svg";